import type CustomWindow from '@/misc/custom-window'

declare const window: CustomWindow

export default {
  computed: {
    useSupplierBetaFeature(): boolean {
      return Boolean(window.settings.use_suppliers_instead_of_hiring_employees)
    },
  },
}
